export const isLoggedIn = () => {
    const authData = localStorage.getItem("Authtoken");
    return authData && authData !== "null";
}

// Check if the user has made a payment
export const isPaid = () => {
    const paymentStatus = localStorage.getItem("payment");
    return paymentStatus && paymentStatus !== "null";
}

// Check if the user is both logged in and has made a payment
export const isAuthenticated = () => {
    return isLoggedIn() && isPaid();
}
